import type { PALETTE } from "$global-providers/mui-provider/palette";
import {
  Chip as MUIChip,
  type ChipProps as MUIChipProps,
} from "@material-ui/core";
import { styled, type Theme } from "@material-ui/core/styles";
import type { PaletteColor } from "@material-ui/core/styles/createPalette";

type ChipColor = keyof typeof PALETTE;
type ChipProps = Omit<MUIChipProps, "color"> & { color?: ChipColor };

const StyledChip = styled(({ color, ...props }: ChipProps) => (
  <MUIChip {...props} />
))<Theme, { color: ChipColor }>(({ theme, color }) => ({
  textTransform: "capitalize",
  fontWeight: theme.typography.fontWeightBold as any,
  fontSize: theme.typography.fontSize,
  borderRadius: theme.shape.borderRadius,
  height: 24,
  backgroundColor: (theme.palette[color] as PaletteColor).main,
  color: (theme.palette[color] as PaletteColor).contrastText,
}));

export const Chip = ({ color = "brand", ...props }: ChipProps) => {
  return <StyledChip color={color} {...props} />;
};

export const StatusChip = styled(Chip)<
  Theme,
  {
    status: "valid" | "invalid" | "disabled";
  }
>(({ theme, status }) => ({
  backgroundColor: {
    valid: `${theme.palette.success.main}30`,
    invalid: `${theme.palette.error.main}30`,
    disabled: theme.palette.disabled.main,
  }[status],
  color: {
    valid: theme.palette.grey[900],
    invalid: theme.palette.grey[900],
    disabled: theme.palette.disabled.contrastText,
  }[status],
}));
